import React from "react";
import { Input, Label } from "@components/input";
import { Button } from "@components/button";

type Props = {
  attachmentId: number;
  fileName: string;
  sortOrder?: number;
  onActionsSubmit: (fileName: string, sortOrder: number) => void;
};

const PopoverActions = ({ attachmentId, fileName, sortOrder, onActionsSubmit }: Props) => {
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);

    const newFileName = formData.get("fileName")?.toString() ?? fileName;
    const newSortOrder = formData.get("sortOrder") ?? sortOrder ?? 1;

    onActionsSubmit(newFileName.trim(), +newSortOrder);
  };

  return (
    <form onSubmit={(event) => handleSubmit(event)}>
      <Label htmlFor={`filename-${attachmentId}`}>
        File Name
        <Input defaultValue={fileName} id={`filename-${attachmentId}`} name="fileName" />
      </Label>
      <Label htmlFor={`sortOrder-${attachmentId}`}>
        Sort Order
        <Input defaultValue={sortOrder} id={`sortOrder-${attachmentId}`} type="number" name="sortOrder" />
      </Label>

      <Button htmlType="submit">Save</Button>
    </form>
  );
};

export default PopoverActions;
